import { PropTypes } from 'react'
import { fromJS } from 'immutable'
import { actions } from 'react-redux-form/immutable'

import { fetchOffering } from './actions'

const OfferingsShow = ({ children }) => (children)

OfferingsShow.onEnter = (store) => (nextState) =>
  store.dispatch(fetchOffering(Number(nextState.params.id)))
    .then((res) => {
      if (!res.error) {
        store.dispatch(actions.change('offeringState', fromJS(res.payload)))
      }
    })

OfferingsShow.propTypes = {
  children: PropTypes.node,
}

export default OfferingsShow



// WEBPACK FOOTER //
// ./src/containers/Setup/Offerings/show.js